import { createContext } from 'react';
import type { MutableRefObject } from 'react';
import type { SatelliteConversationFolderTypeV2 } from '@zg-rentals/ts-satellite-client';
import type { InboxPageMobileView } from '../types/InboxPageMobileView';

type MessageJustSentRef = { conversationId: string; messageId: string; at: number } | null;

type ContextProps = {
  /**
   * Selected conversation
   */
  conversationId?: string;
  /**
   * Selected folder
   */
  folder: SatelliteConversationFolderTypeV2;
  /**
   * Column that is currently in view on mobile
   */
  mobileView: InboxPageMobileView.ConversationList | InboxPageMobileView.MessageList;
  /**
   * Ref set by AddMessage when user sends a message; used to avoid duplicate getMessages refetches
   * (WebSocket handler and ConversationList effect skip refetch when this is set).
   */
  messageJustSentRef?: MutableRefObject<MessageJustSentRef | null>;
};

/**
 * InboxPageContext stores data specific to the inbox page.
 */
export const InboxPageContext = createContext<ContextProps>({} as ContextProps);
export const InboxPageContextProvider = InboxPageContext.Provider;
